import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IChatService = ( createDecorator('IChatService'));
export { IChatService };
